module.exports = __webpack_public_path__ + "static/img/more.39d62d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/more.png
// module id = rziK
// module chunks = 1